<template>
  <v-app id="inspire" :class="{'resetHeigth': parentComponent === 'Dashboard'}">
    <div class="shift-start-end-wrap">
      <template v-if="loading && parentComponent !== 'Dashboard'">
          <div class="mb-6">
            <h2 class="headline">Start/End My Shift</h2>
          </div>
          <v-progress-linear :indeterminate="loading" class="mb-0 mt-0" :class="{ 'no-opacity': !loading }" style="height: 2px;"></v-progress-linear>
      </template>
      <template v-else>
        <div v-if="parentComponent !== 'Dashboard'" class="mb-6">
          <v-layout class="wrap xs12">
            <v-flex>
              <h2 class="headline">{{titleCase(step)}}</h2>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn
              v-if="step === 'end_shift'"
              class="ma-0"
              @click="startBreakOpen"
              color="warning"
            >Start Break</v-btn>
          </v-layout>
        </div>
        <v-card class="shift-card pa-4" :class="{'elevation-2': parentComponent === 'Dashboard', 'mb-2 mx-0': parentComponent === 'Dashboard'}">
          <template v-if="parentComponent === 'Dashboard'">
            <template v-if="loading">
              <div class="mb-2">
                <h2 class="headline pl-2">Start/End My Shift</h2>
              </div>
              <v-progress-linear :indeterminate="loading" class="mb-0 mt-0" :class="{ 'no-opacity': !loading }" style="height: 2px;"></v-progress-linear>
            </template>
            <div v-else class="mb-2">
              <v-layout class="wrap xs12">
                <v-flex>
                  <h2 class="headline pl-2">{{titleCase(step)}}</h2>
                </v-flex>
                <v-spacer></v-spacer>
                <v-menu v-if="parentComponent === 'Dashboard'" offset-y bottom left d-inline-flex @click.native.stop="">
                  <template v-slot:activator="{ on }">
                    <v-btn class="ma-0 rotate-icon" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pa-0">
                    <v-list-item @click="hideWidget">
                        <v-flex class="body-1">
                            <v-icon class="mr-2" color="primary" size="18px">visibility_off</v-icon> Hide Widget
                        </v-flex>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-layout>
            </div>
          </template>
          <v-form>
            <v-container class="grid-list-lg px-0 pt-0 container--fluid">
              <v-layout class="wrap xs12 pa-4" style="max-width: 1000px;">
                <v-flex class="md4 sm6 xs12">
                  <v-text-field
                    :label="step.includes('start') ? 'Odometer Start*' : 'Odometer End*'"
                    v-model="shiftData.odometer"
                    :required="true"
                    :counter="4"
                    v-mask="'####'"
                    placeholder="Please Enter"
                    hint="Enter last 4 digits only"
                    :error-messages="errors($v.shiftData.odometer)"
                    @blur="$v.shiftData.odometer.$touch()"
                    @focus="resetServerValidation"
                  ></v-text-field>
                </v-flex>
                <v-flex class="md4 sm6 xs12">
                  <v-switch
                    :label="`Company vehicle`"
                    prepend-icon="local_shipping"
                    v-model="shiftData.company_vehicle"
                    :disabled="step !== 'start_shift'"
                    class="shift-element"
                    hint="Choose between company and personal vehicle."
                    persistent-hint
                    @focus="resetServerValidation"
                  ></v-switch>
                </v-flex>
                <v-flex class="md4 sm6 xs12">
                  <v-text-field
                    :label="`${ titleCase(step) } Notes`"
                    prepend-icon="comment"
                    v-model="shiftData.note"
                    placeholder="Please Enter"
                    hint="(Optional)"
                    persistent-hint
                    @focus="resetServerValidation"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-alert class="pa-2 mt-2 mx-4 mb-4" :value="$v.shiftData.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">Please fill out all fields correctly.</span>
            </v-alert>
            <v-alert class="pa-2 mt-2 mx-4 mb-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">{{ serverValidationMessage }}</span>
            </v-alert>
            <v-layout class="wrap xs12 px-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn
                v-if="step === 'start_break'"
                class="mt-0"
                @click="startBreakClose"
                text
                color="primary"
              >Cancel</v-btn>
              <v-btn
                v-if="step === 'end_shift' && parentComponent === 'Dashboard'"
                class="my-0 ml-0"
                @click="startBreakOpen"
                color="warning"
              >Start Break</v-btn>
              <v-btn
                class="my-0 mr-0 ml-2"
                @click="callMethod(step)"
                :loading="shiftLoading"
                :disabled="shiftLoading"
                color="primary"
              >{{ buttonName(step) }}</v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </template>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import { mask } from 'vue-the-mask'
import { validationMixin } from "vuelidate";
import { required, email, helpers } from "vuelidate/lib/validators";
import { valMessages, getValMessage } from "@/common/error-messages";
import { mapActions } from "vuex";

const validations = {
  shiftData: {
    odometer: { required, odometer: v => !helpers.req(v) || v.length === 4 }
  }
};

export default {
  mixins: [validationMixin],
  validations,
  props: {
    parentComponent: {
      type: String,
      default: () => 'UserLayout'
    }
  },
  directives: {mask},
  data: () => ({
    no_data: [null, '', undefined, 'null'],
    step: 'start_shift',
    shift: null,
    shift_breaks: null,
    loading: false,
    shiftData: {},
    shiftLoading: false,
    serverValidation: true,
    serverValidationMessage: 'Oops something went wrong...'
  }),
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize(loading = true) {
      if (loading) this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get("/time_and_mileage/get_shift")
          .then(res => {
            this.loading = false
            let data = res.data;
            this.shift = data.shift;
            this.shift_breaks = data.shift_breaks

            if (data.shift === null || (data.shift && data.shift.start_time && moment().format('YYYY[-]MM[-]DD') !== moment(data.shift.start_time).format('YYYY[-]MM[-]DD'))) {
              if (loading || this.step !== 'start_shift') { this.shiftData.company_vehicle = false }
              this.step = "start_shift";
            } else {
              this.shiftData.company_vehicle = Boolean(this.shift.start_company_vehicle)
              
              if (data.shift_breaks.lenght !== 0 && data.shift_breaks.some(b => {
                return b.end_time === null;
              })) { 
                this.step = "end_break"
              } 
              else { 
                if(this.step !== 'start_break') { this.step = "end_shift" } 
              }
            }

            this.$v.$reset()
            resolve(this.step)
          })
          .catch(error => {
            console.log(error)
            reject(false)
          })
      })
    },
    reload() {
      if(!this.no_data.includes(this.shift) && 
        !this.no_data.includes(this.shift.start_time) && 
        moment().format('YYYY[-]MM[-]DD') !== moment(this.shift.start_time).format('YYYY[-]MM[-]DD')) {
          this.initialize()
          this.resetServerValidation()
      }
    },
    callMethod(m) {
      this[m]()
    },
    buttonName(step) {
      if(step === "start_shift") {
        return "Clock In"
      } else if (step === "end_shift") {
        return "Clock Out"
      } else {
        return this.titleCase(step)
      }
    },
    start_shift() {
      this.resetServerValidation()
      this.$v.shiftData.$touch()
      if(!this.$v.shiftData.$invalid) {
        this.shiftLoading = true
        this.initialize(false)
          .then(response => {
            if(response === 'start_shift') {
              let body = this.shiftData
              body.company_vehicle = Number(body.company_vehicle)
              
              ApiService.put('/time_and_mileage/start_shift', body)
                .then(res => {                                                        
                  this.vEmit({ 
                    name: "notification", 
                    data: {
                      status: 'success', 'text': 'New Shift has been successfully started.'
                    }
                  });
                  this.shiftLoading = false
                  this.shiftData = {}
                  this.initialize();
                })
                .catch(({ res }) => {
                    this.shiftLoading = false
                    this.serverValidation = false
                    if(res.data.error){
                        this.serverValidationMessage = _.upperFirst(res.data.error.replace(/_/g, ' '))
                    }
                })
            } else {
              this.vEmit({ 
                name: "notification", 
                data: {
                  status: 'error', 
                  text: 'Unable to perform action. The shift status has been already changed.'
                }
              });
              this.shiftLoading = false
              this.shiftData = { company_vehicle: Boolean(this.shift.start_company_vehicle) }
            }
          })
      }
    },
    end_shift() {
      this.reload()
      this.resetServerValidation()
      this.$v.shiftData.$touch()
      if(!this.$v.shiftData.$invalid) {
        this.shiftLoading = true
        this.initialize(false).then(response => {
          if(response === 'end_shift') {
            let body = this.shiftData
            body.company_vehicle = Number(body.company_vehicle)
            body.shift_id = this.shift.id
            
            ApiService.put('/time_and_mileage/end_shift', body)
              .then(res => {                                                        
                this.vEmit({ 
                  name: "notification", 
                  data: {
                    status: 'success',
                    text: 'Shift has been successfully ended.'
                  }
                });
                this.shiftLoading = false
                this.shiftData = {}
                this.initialize();
              })
              .catch(({ res }) => {
                  this.shiftLoading = false
                  this.serverValidation = false
                  if(res.data.error){
                      this.serverValidationMessage = _.upperFirst(res.data.error.replace(/_/g, ' '))
                  }
              })
          } else {
            this.vEmit({ 
              name: "notification", 
              data: {
                status: 'error',
                text: 'Unable to perform action. The shift status has been already changed.'
              }
            });
            this.shiftLoading = false
            this.shiftData = { company_vehicle: Boolean(this.shift.start_company_vehicle) }
          }         
        })
      }
    },
    startBreakOpen () {
      this.reload()
      this.resetServerValidation()
      this.step = 'start_break'
      this.$v.$reset()
      this.shiftData = {
        company_vehicle: Boolean(this.shift.start_company_vehicle)
      }
    },
    start_break() {
      this.reload()
      this.resetServerValidation()
      this.$v.shiftData.$touch()
      if(!this.$v.shiftData.$invalid) {
        this.shiftLoading = true
        this.initialize(false).then(response => {
          if(response === 'start_break') {
            let body = this.shiftData
            body.company_vehicle = Number(body.company_vehicle)
            body.shift_id = this.shift.id
            
            ApiService.put('/time_and_mileage/start_shift_break', body)
              .then(res => {                                                        
                this.vEmit({ 
                  name: "notification", 
                  data: {
                    status: 'success', text: 'New Break has been successfully started.'
                  }    
                });
                this.shiftLoading = false
                this.shiftData = {}
                this.initialize();
              })
              .catch(({ res }) => {
                  this.shiftLoading = false
                  this.serverValidation = false
                  if(res.data.error){
                      this.serverValidationMessage = _.upperFirst(res.data.error.replace(/_/g, ' '))
                  }
              })
          } else {
            this.vEmit({ 
              name: "notification", 
              data: {
                status: 'error', 
                text: 'Unable to perform action. The shift status has been already changed.'
              }
            });
            this.shiftLoading = false
            this.shiftData = { company_vehicle: Boolean(this.shift.start_company_vehicle) }
          }   
        })
      }
    },
    startBreakClose () {
      this.reload()
      this.resetServerValidation()
      this.step = 'end_shift'
      this.shiftData = {
        company_vehicle: Boolean(this.shift.start_company_vehicle)
      }
      this.$v.$reset()
    },
    end_break() {
      this.reload()
      this.resetServerValidation()
      this.$v.shiftData.$touch()
      if(!this.$v.shiftData.$invalid) {
        this.shiftLoading = true
        this.initialize(false).then(response => {
          if(response === 'end_break') {
            let body = this.shiftData
            body.company_vehicle = Number(body.company_vehicle)
            body.shift_id = this.shift.id
            body.break_id = this.shift_breaks[0].id
            
            ApiService.put('/time_and_mileage/end_shift_break', body)
              .then(res => {                                                        
                this.vEmit({ 
                  name: "notification", 
                  data: {
                    status: 'success', text: 'Break has been successfully ended.'
                  }
                });
                this.shiftLoading = false
                this.shiftData = {}
                this.initialize();
              })
              .catch(({ res }) => {
                  this.shiftLoading = false
                  this.serverValidation = false
                  if(res.data.error){
                      this.serverValidationMessage = _.upperFirst(res.data.error.replace(/_/g, ' '))
                  }
              })
          } else {
            this.vEmit({ 
              name: "notification", 
              data: { 
                status: 'error', 'text': 'Unable to perform action. The shift status has been already changed.'
              }
            });
            this.shiftLoading = false
            this.shiftData = { company_vehicle: Boolean(this.shift.start_company_vehicle) }
          }
        })
      }
    },
    hideWidget() {
      this.$emit('hideWidget', 'start_end_shift')
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = 'Oops something went wrong...'
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '));
    },
    errors: getValMessage(valMessages)(validations)
  }
};
</script>
<style>
  .resetHeigth .v-application--wrap {
    min-height: initial;
  }
</style>
